export default function Triangle(props: { height?: string | number }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={props.height}
      viewBox='-2 -2 568 206'
    >
      <path
        d='M0 205.5H567.5L567 0C428.5 122.5 214 178 0 205.5Z'
        fill='#3fa110'
      />
    </svg>
  );
}

Triangle.defaultProps = {
  height: 206,
};
